import { Component, OnInit } from '@angular/core';
import { NodeBuilder } from '../../../../../../../shared/models';
import { OtpNode } from './otp';
import { FormGroup } from '@angular/forms';

const NODE_TYPE = 'otp';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent extends NodeBuilder implements OnInit {

  otpForm: FormGroup;

  readonly KEYWORD_FIELD = {
    dataType: 'keyword',
    type: 'chips',
    label: '',
    placeholder: 'Add keyword(s)',
    validators: {
      maxLength: 5,
      duplicate: true,
    },
  };

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.otpForm = OtpNode.toForm(stepData, this.canEdit);
  }

  get getStepData(): {} {
    const nodeData = new OtpNode();
    nodeData.setMenuData(this.otpForm.getRawValue());
    return nodeData.nodeData;
  }

  get isNodeValid(): boolean {
    this.otpForm.markAllAsTouched();
    return this.otpForm.valid;
  }

}
